import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import NumberFormat from 'react-number-format';
import getConfig from '../../../../config';
import { buildGatewayUrl } from '../../../../state/ipfs';
import { projectTypes } from '../../../../constans/constans';
import { getProjectType } from '../../../../utils/helpers';

const { projectDurationType } = getConfig();

const ProjectInfo = ({ data, remainingUpload, icon, filesList }) => {
  const translate = useIntl();
  const noData = '- Unavailable until project start -';

  const {
    type = '',
    codePlus = '',
    square = '',
    avgTrees = '',
    benefits = '',
    projectDuration = '',
    startTimeProject = 0,
    aboutProject = '',
    goals = '',
    masters = '',
    treeSpecies = '',
    filesCidDir = '',
  } = data;
  const remainingNumber = remainingUpload >= 0 ? remainingUpload : noData;

  const getDuration = () => {
    if (startTimeProject) {
      let endProject;
      const startProject = new Date(startTimeProject / 1e6).getFullYear();
      const currentYear = new Date().getFullYear();

      if (projectDurationType === 'year') endProject = startProject + +projectDuration;
      if (projectDurationType === 'day') endProject = startProject + Math.floor(+projectDuration / 365);

      const totalDuration = `${startProject} - ${endProject}`;
      const remainingDuration = currentYear > endProject ? noData : `${currentYear} - ${endProject}`;
      return { totalDuration, remainingDuration };
    }
    return { totalDuration: noData, remainingDuration: noData };
  };

  const { totalDuration, remainingDuration } = useMemo(getDuration, []);

  return (
    <>
      <h3 className="project__info-firstMain">
        {translate.formatMessage({ id: 'wizardForm.step1.generalInformation' })}
      </h3>
      <div className="project__info-main">

        <span className="project__info-mainItem">
          {translate.formatMessage({ id: 'wizardForm.step2.map.projectArea' })}
          {' '}
          (ha):
          {' '}
          <b>
            <NumberFormat
              value={square}
              displayType="text"
              thousandSeparator
              decimalScale={3}
            />
            {' '}
            ha
          </b>
        </span>
        <span className="project__info-mainItem">
          {translate.formatMessage({ id: 'projectInfo.remainingUploads' })}
          :
          {' '}
          <b>{remainingNumber}</b>
        </span>
        <span className="project__info-mainItem">
          {translate.formatMessage({ id: 'projectInfo.totalProjectDuration' })}
          :
          {' '}
          <b>{totalDuration}</b>
        </span>
        <span className="project__info-mainItem">
          {translate.formatMessage({ id: 'projectInfo.remainingDuration' })}
          :
          {' '}
          <b>{remainingDuration}</b>
        </span>
      </div>
      <div className="project__info-description">
        <h3 className="project__info-title">
          {translate.formatMessage({ id: 'wizardForm.step3.projectDescription' })}
        </h3>
        <p className="project__info-text">
          {aboutProject}
        </p>
      </div>
      <div className="project__info-goals">
        <h3 className="project__info-title">
          {translate.formatMessage({ id: 'wizardForm.step3.projectGoals' })}
        </h3>
        <p className="project__info-text">
          {goals}
        </p>
      </div>
      <div className="project__info-communities">
        <h3 className="project__info-title">
          {translate.formatMessage({ id: 'projectInfo.stakeholders' })}
        </h3>
        <p className="project__info-text">
          {masters}
        </p>
      </div>
      <div className="project__info-benefits">
        <h3 className="project__info-title">
          {translate.formatMessage({ id: 'wizardForm.step3.coBenefits' })}
        </h3>
        <p className="project__info-text">
          {benefits}
        </p>
      </div>
      <div className="project__info-species">
        <h3 className="project__info-title">
          {translate.formatMessage({ id: 'wizardForm.step3.treeSpecies' })}
        </h3>
        <p className="project__info-text">
          {treeSpecies}
        </p>
      </div>
      <div className="project__info-type">
        <h3 className="project__info-title">
          {translate.formatMessage({ id: 'wizardForm.step1.projectType' })}
        </h3>
        <p className="project__info-text">
          {getProjectType(type, projectTypes(translate)) ? translate.formatMessage({ id: getProjectType(type, projectTypes(translate)) }) : ''}
        </p>
      </div>
      <div className="project__info-density">
        <h3 className="project__info-title">
          {translate.formatMessage({ id: 'wizardForm.step3.averageTreeDensity' })}
        </h3>
        <p className="project__info-text">
          {avgTrees}
        </p>
      </div>
      <div className="project__info-code">
        <h3 className="project__info-title">
          {translate.formatMessage({ id: 'wizardForm.step2.codePlus' })}
        </h3>
        <p className="project__info-text">
          {codePlus}
        </p>
      </div>
      <div className="project__info-cover">
        <h3 className="project__info-title">
          {translate.formatMessage({ id: 'wizardForm.step1.coverPhoto' })}
        </h3>
        {icon ? <img src={icon} alt="Cover" /> : (
          <span className="project__loading-text">
            {translate.formatMessage({ id: 'projectInfo.loading' })}
          </span>
        )}
      </div>
      <div className="project__info-documentation">
        <h3 className="project__info-title">
          {translate.formatMessage({ id: 'wizardForm.step3.projectDocumentation' })}
        </h3>
        {!filesCidDir ? (
          <p>
            {translate.formatMessage({ id: 'projectInfo.noProjectDocumentation' })}
          </p>
        ) : filesList.length ? (
          <ul className="project__info-files">
            {filesList.map((item, index) => (
              <li className="file-item" key={`${item.path}${index + Date.now()}`}>
                <a href={buildGatewayUrl(data.filesCidDir, item.path)} target="_blank" rel="noreferrer">
                  {index + 1}
                  .
                  {' '}
                  {item.path}
                </a>
              </li>
            ))}
          </ul>
        ) : (
          <span className="project__loading-text">{translate.formatMessage({ id: 'projectInfo.loading' })}</span>
        )}
      </div>
    </>
  );
};

export default ProjectInfo;
